import { VideoAssetData } from '@superfunnel/types/asset-data';

export type VideoMetadata = Pick<
  VideoAssetData,
  'width' | 'height' | 'aspectRatio' | 'duration' | 'size'
>;

export const extractVideoMetadata = (file: File): Promise<VideoMetadata> =>
  new Promise((resolve, reject) => {
    const video = document.createElement('video');
    const url = URL.createObjectURL(file);

    const cleanup = () => {
      video.onloadedmetadata = null;
      video.onerror = null;
      video.removeAttribute('src');
      video.load();
      URL.revokeObjectURL(url);
    };

    video.preload = 'metadata';
    video.src = url;

    video.onloadedmetadata = () => {
      const width = video.videoWidth || undefined;
      const height = video.videoHeight || undefined;
      const duration = Number.isFinite(video.duration)
        ? video.duration
        : undefined;

      cleanup();
      resolve({
        width,
        height,
        aspectRatio: width && height ? width / height : undefined,
        duration,
        size: file.size,
      });
    };

    video.onerror = () => {
      cleanup();
      reject(new Error(`Could not read video metadata for "${file.name}".`));
    };
  });
